module.exports = __webpack_public_path__ + "img/tools4.e801fcfc.png";